export default "__VITE_ASSET__677822ac__"